export enum CoinSide {
  Heads = 'heads',
  Tails = 'tails',
}
